import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_md,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const container = css`
  min-height: ${spacing(30)};
`

export const loading = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
`

export const visuallyHidden = css`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

export const skeletonRow = css`
  display: grid;
  grid-template-columns: ${spacing(10)} minmax(0, 1fr);
  gap: ${spacing(3)};
`

export const skeletonAvatar = css`
  background: ${base_colorSurfaceSecondary};
  border: 1px solid ${base_colorContentBorder};
  border-radius: 100%;
  height: ${spacing(10)};
  width: ${spacing(10)};
`

export const skeletonContent = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  padding-top: ${spacing(1)};
`

export const skeletonHeading = css`
  background: ${base_colorSurfaceSecondary};
  border-radius: ${spacing(1)};
  height: ${spacing(4)};
  width: 45%;
`

export const skeletonEvent = css`
  background: ${base_colorSurfaceSecondary};
  border-radius: ${spacing(2)};
  height: ${spacing(12)};
  width: 100%;
`

export const empty = css`
  align-items: center;
  color: ${text_colorTextSecondary};
  display: flex;
  flex-direction: column;
  font-family: ${font_family_weight_regular};
  ${font_md};
  justify-content: center;
  min-height: ${spacing(30)};
  text-align: center;
`

export const error = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};

  p {
    margin: 0;
  }
`

export const errorTitle = css`
  color: ${text_colorTextPrimary};
  font-family: ${font_family_weight_medium};
  ${font_md};
`

export const actions = css`
  align-items: flex-start;
  display: flex;
`

export const loadMore = css`
  display: flex;
  justify-content: center;
  padding-top: ${spacing(5)};
`

export const composer = css`
  display: flex;
  padding-bottom: ${spacing(5)};

  > button {
    margin-left: auto;
  }
`

export const projectionStatus = css`
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_regular};
  ${font_md};
  margin: 0;
  padding-bottom: ${spacing(5)};
`
